import * as formInputNames from '../../../../../consts/form/formInputNames';
import * as formItemTypes from '../../../../../consts/form/formItemTypes';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import * as modalTypes from '../../../../../consts/modals/modalTypes';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import helpers from '../../../../../utils/helpers';

const getChirpStackProfileModalContent = (modalType, initialData) => {
    const ls = getLocalizedStrings();
    const isAdd = modalType === modalTypes.SETTINGS_ADD_CHIRPSTACK_PROFILE_TYPE;

    const initialValues = {
        [formInputNames.CHIRPSTACK_PROFILE_NAME]: initialData?.value,
        [formInputNames.CHIRPSTACK_PROFILE_DESCRIPTION]: initialData?.description,
        [formInputNames.CHIRPSTACK_PROFILE_UPLINK_INTERVAL]: initialData?.uplinkInterval || 3600,
    };

    const formContent = [
        {
            key: helpers.guid(),
            required: true,
            name: formInputNames.CHIRPSTACK_PROFILE_NAME,
            label: ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_FORM_NAME_FIELD_LABEL],
            placeholder: ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_FORM_NAME_FIELD_PLACEHOLDER],
            errorMessage: ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_FORM_NAME_FIELD_ERROR],
        },
        {
            key: helpers.guid(),
            required: false,
            name: formInputNames.CHIRPSTACK_PROFILE_DESCRIPTION,
            label: ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_FORM_DESCRIPTION_FIELD_LABEL],
            placeholder: ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_FORM_DESCRIPTION_FIELD_PLACEHOLDER],
        },
        {
            key: helpers.guid(),
            required: true,
            formItemType: formItemTypes.INPUT,
            name: formInputNames.CHIRPSTACK_PROFILE_UPLINK_INTERVAL,
            label: ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_FORM_UPLINK_FIELD_LABEL],
            placeholder: '3600',
        },
    ];

    return {
        title: isAdd
            ? ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_ADD_FORM_TITLE]
            : ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_EDIT_FORM_TITLE],
        submitButton: isAdd
            ? ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_ADD_FORM_SUBMIT_BUTTON]
            : ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_EDIT_FORM_SUBMIT_BUTTON],
        cancelButton: ls[localizationKeys.SETTINGS_CHIRPSTACK_PROFILE_FORM_CANCEL_BUTTON],
        initialValues,
        formContent,
    };
};

export default {getChirpStackProfileModalContent};
